import axiosInstance from "~/shared/api/axios-instance";

/** 번역 대상 1건. id 는 응답 매핑용 불투명 토큰(예: "line-12" / "zone-7"). */
export interface GenerateKeysItem {
  id: string;
  name: string;
  /** 이 항목이 속한 도면 이름. Key 규칙 고객사의 {floor} 출처(예: "2층 가전매장"→2f). */
  floor_plan_name?: string;
}

export interface GenerateKeysResult {
  id: string;
  key_suffix: string;
}

/**
 * 한국어 라인/구역 이름을 영문 Key suffix 로 일괄 변환 (BE Claude few-shot).
 * 저장은 하지 않고 제안만 받는다. FE 가 결과를 pending 값으로 채운다.
 */
export async function generateKeys(branchUid: string, items: GenerateKeysItem[]) {
  const { data } = await axiosInstance.post<{ results: GenerateKeysResult[] }>(
    `branches/${branchUid}/generate-keys/`,
    { items },
  );
  return data;
}
